import flag_tr_0 from '../../../../assets/img/flags/tr.svg';
import flag_us_1 from '../../../../assets/img/flags/us.svg';
import flag_af_2 from '../../../../assets/img/flags/af.svg';
import flag_de_3 from '../../../../assets/img/flags/de.svg';
import flag_as_4 from '../../../../assets/img/flags/as.svg';
import flag_ad_5 from '../../../../assets/img/flags/ad.svg';
import flag_ao_6 from '../../../../assets/img/flags/ao.svg';
import flag_ai_7 from '../../../../assets/img/flags/ai.svg';
import flag_ag_8 from '../../../../assets/img/flags/ag.svg';
import flag_ar_9 from '../../../../assets/img/flags/ar.svg';
import flag_al_10 from '../../../../assets/img/flags/al.svg';
import flag_aw_11 from '../../../../assets/img/flags/aw.svg';
import flag_sh_ac_12 from '../../../../assets/img/flags/sh-ac.svg';
import flag_au_13 from '../../../../assets/img/flags/au.svg';
import flag_at_14 from '../../../../assets/img/flags/at.svg';
import flag_az_15 from '../../../../assets/img/flags/az.svg';
import flag_pt_16 from '../../../../assets/img/flags/pt.svg';
import flag_ae_17 from '../../../../assets/img/flags/ae.svg';
import flag_bs_18 from '../../../../assets/img/flags/bs.svg';
import flag_bh_19 from '../../../../assets/img/flags/bh.svg';
import flag_bd_20 from '../../../../assets/img/flags/bd.svg';
import flag_bb_21 from '../../../../assets/img/flags/bb.svg';
import flag_ws_22 from '../../../../assets/img/flags/ws.svg';
import flag_be_23 from '../../../../assets/img/flags/be.svg';
import flag_bz_24 from '../../../../assets/img/flags/bz.svg';
import flag_bj_25 from '../../../../assets/img/flags/bj.svg';
import flag_bm_26 from '../../../../assets/img/flags/bm.svg';
import flag_by_27 from '../../../../assets/img/flags/by.svg';
import flag_bt_28 from '../../../../assets/img/flags/bt.svg';
import flag_mm_29 from '../../../../assets/img/flags/mm.svg';
import flag_bo_30 from '../../../../assets/img/flags/bo.svg';
import flag_ba_31 from '../../../../assets/img/flags/ba.svg';
import flag_bw_32 from '../../../../assets/img/flags/bw.svg';
import flag_br_33 from '../../../../assets/img/flags/br.svg';
import flag_vg_34 from '../../../../assets/img/flags/vg.svg';
import flag_bn_35 from '../../../../assets/img/flags/bn.svg';
import flag_bg_36 from '../../../../assets/img/flags/bg.svg';
import flag_bf_37 from '../../../../assets/img/flags/bf.svg';
import flag_bi_38 from '../../../../assets/img/flags/bi.svg';
import flag_ky_39 from '../../../../assets/img/flags/ky.svg';
import flag_gi_40 from '../../../../assets/img/flags/gi.svg';
import flag_dz_41 from '../../../../assets/img/flags/dz.svg';
import flag_dj_42 from '../../../../assets/img/flags/dj.svg';
import flag_ck_43 from '../../../../assets/img/flags/ck.svg';
import flag_td_44 from '../../../../assets/img/flags/td.svg';
import flag_cz_45 from '../../../../assets/img/flags/cz.svg';
import flag_cn_46 from '../../../../assets/img/flags/cn.svg';
import flag_dk_47 from '../../../../assets/img/flags/dk.svg';
import flag_dg_48 from '../../../../assets/img/flags/dg.svg';
import flag_dm_49 from '../../../../assets/img/flags/dm.svg';
import flag_do_50 from '../../../../assets/img/flags/do.svg';
import flag_ec_51 from '../../../../assets/img/flags/ec.svg';
import flag_gq_52 from '../../../../assets/img/flags/gq.svg';
import flag_sv_53 from '../../../../assets/img/flags/sv.svg';
import flag_id_54 from '../../../../assets/img/flags/id.svg';
import flag_er_55 from '../../../../assets/img/flags/er.svg';
import flag_am_56 from '../../../../assets/img/flags/am.svg';
import flag_ee_57 from '../../../../assets/img/flags/ee.svg';
import flag_et_58 from '../../../../assets/img/flags/et.svg';
import flag_fk_59 from '../../../../assets/img/flags/fk.svg';
import flag_fo_60 from '../../../../assets/img/flags/fo.svg';
import flag_ma_61 from '../../../../assets/img/flags/ma.svg';
import flag_fj_62 from '../../../../assets/img/flags/fj.svg';
import flag_ci_63 from '../../../../assets/img/flags/ci.svg';
import flag_ph_64 from '../../../../assets/img/flags/ph.svg';
import flag_fi_65 from '../../../../assets/img/flags/fi.svg';
import flag_fr_66 from '../../../../assets/img/flags/fr.svg';
import flag_pf_68 from '../../../../assets/img/flags/pf.svg';
import flag_ga_69 from '../../../../assets/img/flags/ga.svg';
import flag_gm_70 from '../../../../assets/img/flags/gm.svg';
import flag_gh_71 from '../../../../assets/img/flags/gh.svg';
import flag_gn_72 from '../../../../assets/img/flags/gn.svg';
import flag_gw_73 from '../../../../assets/img/flags/gw.svg';
import flag_gd_74 from '../../../../assets/img/flags/gd.svg';
import flag_gl_75 from '../../../../assets/img/flags/gl.svg';
import flag_guadeloupe_76 from '../../../../assets/img/flags/guadeloupe.svg';
import flag_et__guam__77 from '../../../../assets/img/flags/et (guam).svg';
import flag_fk__Guatemala__78 from '../../../../assets/img/flags/fk (Guatemala).svg';
import flag_gy_79 from '../../../../assets/img/flags/gy.svg';
import flag_za_80 from '../../../../assets/img/flags/za.svg';
import flag_ge_81 from '../../../../assets/img/flags/ge.svg';
import flag_ht_82 from '../../../../assets/img/flags/ht.svg';
import flag_hr_83 from '../../../../assets/img/flags/hr.svg';
import flag_in_84 from '../../../../assets/img/flags/in.svg';
import flag_nl_85 from '../../../../assets/img/flags/nl.svg';
import flag_na__netherlandsantilles__86 from '../../../../assets/img/flags/na (netherlandsantilles).svg';
import flag_hn_87 from '../../../../assets/img/flags/hn.svg';
import flag_hk_88 from '../../../../assets/img/flags/hk.svg';
import flag_iq_89 from '../../../../assets/img/flags/iq.svg';
import flag_vg_90 from '../../../../assets/img/flags/vg.svg';
import flag_gb_91 from '../../../../assets/img/flags/gb.svg';
import flag_ir_92 from '../../../../assets/img/flags/ir.svg';
import flag_ie_93 from '../../../../assets/img/flags/ie.svg';
import flag_il_94 from '../../../../assets/img/flags/il.svg';
import flag_se_95 from '../../../../assets/img/flags/se.svg';
import flag_ch_96 from '../../../../assets/img/flags/ch.svg';
import flag_it_97 from '../../../../assets/img/flags/it.svg';
import flag_is_99 from '../../../../assets/img/flags/is.svg';
import flag_jm_100 from '../../../../assets/img/flags/jm.svg';
import flag_jp_101 from '../../../../assets/img/flags/jp.svg';
import flag_cy_102 from '../../../../assets/img/flags/cy.svg';
import flag_kh_103 from '../../../../assets/img/flags/kh.svg';
import flag_cm_104 from '../../../../assets/img/flags/cm.svg';
import flag_ca_105 from '../../../../assets/img/flags/ca.svg';
import flag_cv_106 from '../../../../assets/img/flags/cv.svg';
import flag_qa_107 from '../../../../assets/img/flags/qa.svg';
import flag_kz_108 from '../../../../assets/img/flags/kz.svg';
import flag_ke_109 from '../../../../assets/img/flags/ke.svg';
import flag_cy_110 from '../../../../assets/img/flags/cy.svg';
import flag_kg_111 from '../../../../assets/img/flags/kg.svg';
import flag_ki_112 from '../../../../assets/img/flags/ki.svg';
import flag_co_113 from '../../../../assets/img/flags/co.svg';
import flag_km_114 from '../../../../assets/img/flags/km.svg';
import flag_cd_115 from '../../../../assets/img/flags/cd.svg';
import flag_kr_116 from '../../../../assets/img/flags/kr.svg';
import flag_cr_117 from '../../../../assets/img/flags/cr.svg';
import flag_kw_118 from '../../../../assets/img/flags/kw.svg';
import flag_kp_119 from '../../../../assets/img/flags/kp.svg';
import flag_cu_120 from '../../../../assets/img/flags/cu.svg';
import flag_la_121 from '../../../../assets/img/flags/la.svg';
import flag_ls_122 from '../../../../assets/img/flags/ls.svg';
import flag_lv_123 from '../../../../assets/img/flags/lv.svg';
import flag_lr_124 from '../../../../assets/img/flags/lr.svg';
import flag_ly_125 from '../../../../assets/img/flags/ly.svg';
import flag_li_126 from '../../../../assets/img/flags/li.svg';
import flag_lt_127 from '../../../../assets/img/flags/lt.svg';
import flag_lb_128 from '../../../../assets/img/flags/lb.svg';
import flag_lu_129 from '../../../../assets/img/flags/lu.svg';
import flag_hu_130 from '../../../../assets/img/flags/hu.svg';
import flag_mg_131 from '../../../../assets/img/flags/mg.svg';
import flag_mo_132 from '../../../../assets/img/flags/mo.svg';
import flag_mk_133 from '../../../../assets/img/flags/mk.svg';
import flag_mw_134 from '../../../../assets/img/flags/mw.svg';
import flag_mv_135 from '../../../../assets/img/flags/mv.svg';
import flag_my_136 from '../../../../assets/img/flags/my.svg';
import flag_ml_137 from '../../../../assets/img/flags/ml.svg';
import flag_mh_138 from '../../../../assets/img/flags/mh.svg';
import flag_mt_139 from '../../../../assets/img/flags/mt.svg';
import flag_mp_140 from '../../../../assets/img/flags/mp.svg';
import flag_mq_141 from '../../../../assets/img/flags/mq.svg';
import flag_mx_142 from '../../../../assets/img/flags/mx.svg';
import flag_cf_143 from '../../../../assets/img/flags/cf.svg';
import flag_eg_144 from '../../../../assets/img/flags/eg.svg';
import flag_fm_145 from '../../../../assets/img/flags/fm.svg';
import flag_mn_146 from '../../../../assets/img/flags/mn.svg';
import flag_md_147 from '../../../../assets/img/flags/md.svg';
import flag_mc_148 from '../../../../assets/img/flags/mc.svg';
import flag_ms_149 from '../../../../assets/img/flags/ms.svg';
import flag_mu_150 from '../../../../assets/img/flags/mu.svg';
import flag_mr_151 from '../../../../assets/img/flags/mr.svg';
import flag_mz_152 from '../../../../assets/img/flags/mz.svg';
import flag_ru_153 from '../../../../assets/img/flags/ru.svg';
import flag_ru_154 from '../../../../assets/img/flags/ru.svg';
import flag_na_155 from '../../../../assets/img/flags/na.svg';
import flag_nr_156 from '../../../../assets/img/flags/nr.svg';
import flag_np_157 from '../../../../assets/img/flags/np.svg';
import flag_ne_158 from '../../../../assets/img/flags/ne.svg';
import flag_ng_159 from '../../../../assets/img/flags/ng.svg';
import flag_ni_160 from '../../../../assets/img/flags/ni.svg';
import flag_nu_161 from '../../../../assets/img/flags/nu.svg';
import flag_nf_162 from '../../../../assets/img/flags/nf.svg';
import flag_no_163 from '../../../../assets/img/flags/no.svg';
import flag_uz_164 from '../../../../assets/img/flags/uz.svg';
import flag_pk_165 from '../../../../assets/img/flags/pk.svg';
import flag_pw_166 from '../../../../assets/img/flags/pw.svg';
import flag_pa_167 from '../../../../assets/img/flags/pa.svg';
import flag_pg_168 from '../../../../assets/img/flags/pg.svg';
import flag_py_169 from '../../../../assets/img/flags/py.svg';
import flag_pe_170 from '../../../../assets/img/flags/pe.svg';
import flag_pl_171 from '../../../../assets/img/flags/pl.svg';
import flag_pt_172 from '../../../../assets/img/flags/pt.svg';
import flag_pr_173 from '../../../../assets/img/flags/pr.svg';
import flag_ru_174 from '../../../../assets/img/flags/ru.svg';
import flag_reunyon_175 from '../../../../assets/img/flags/reunyon.svg';
import flag_ro_176 from '../../../../assets/img/flags/ro.svg';
import flag_rw_177 from '../../../../assets/img/flags/rw.svg';
import flag_ru_178 from '../../../../assets/img/flags/ru.svg';
import flag_ru_179 from '../../../../assets/img/flags/ru.svg';
import flag_ru_180 from '../../../../assets/img/flags/ru.svg';
import flag_ru_181 from '../../../../assets/img/flags/ru.svg';
import flag_ru_182 from '../../../../assets/img/flags/ru.svg';
import flag_sm_183 from '../../../../assets/img/flags/sm.svg';
import flag_st_184 from '../../../../assets/img/flags/st.svg';
import flag_sn_185 from '../../../../assets/img/flags/sn.svg';
import flag_sc_186 from '../../../../assets/img/flags/sc.svg';
import flag_rs_187 from '../../../../assets/img/flags/rs.svg';
import flag_sl_188 from '../../../../assets/img/flags/sl.svg';
import flag_sg_189 from '../../../../assets/img/flags/sg.svg';
import flag_sk_190 from '../../../../assets/img/flags/sk.svg';
import flag_si_191 from '../../../../assets/img/flags/si.svg';
import flag_sb_192 from '../../../../assets/img/flags/sb.svg';
import flag_so_193 from '../../../../assets/img/flags/so.svg';
import flag_lk_194 from '../../../../assets/img/flags/lk.svg';
import flag_kn_196 from '../../../../assets/img/flags/kn.svg';
import flag_lc_197 from '../../../../assets/img/flags/lc.svg';
import flag_sx_198 from '../../../../assets/img/flags/sx.svg';
import flag_pm_199 from '../../../../assets/img/flags/pm.svg';
import flag_vc_200 from '../../../../assets/img/flags/vc.svg';
import flag_sd_201 from '../../../../assets/img/flags/sd.svg';
import flag_sr_202 from '../../../../assets/img/flags/sr.svg';
import flag_sy_203 from '../../../../assets/img/flags/sy.svg';
import flag_sa_204 from '../../../../assets/img/flags/sa.svg';
import flag_sz_205 from '../../../../assets/img/flags/sz.svg';
import flag_cl_206 from '../../../../assets/img/flags/cl.svg';
import flag_tj_207 from '../../../../assets/img/flags/tj.svg';
import flag_tz_208 from '../../../../assets/img/flags/tz.svg';
import flag_ru_209 from '../../../../assets/img/flags/ru.svg';
import flag_ru_210 from '../../../../assets/img/flags/ru.svg';
import flag_th_211 from '../../../../assets/img/flags/th.svg';
import flag_tw_212 from '../../../../assets/img/flags/tw.svg';
import flag_tg_213 from '../../../../assets/img/flags/tg.svg';
import flag_tk_214 from '../../../../assets/img/flags/tk.svg';
import flag_to_215 from '../../../../assets/img/flags/to.svg';
import flag_tt_216 from '../../../../assets/img/flags/tt.svg';
import flag_tn_217 from '../../../../assets/img/flags/tn.svg';
import flag_tc_218 from '../../../../assets/img/flags/tc.svg';
import flag_tv_219 from '../../../../assets/img/flags/tv.svg';
import flag_tm_220 from '../../../../assets/img/flags/tm.svg';
import flag_vi_221 from '../../../../assets/img/flags/vi.svg';
import flag_ug_222 from '../../../../assets/img/flags/ug.svg';
import flag_ua_223 from '../../../../assets/img/flags/ua.svg';
import flag_om_224 from '../../../../assets/img/flags/om.svg';
import flag_uy_225 from '../../../../assets/img/flags/uy.svg';
import flag_jo_226 from '../../../../assets/img/flags/jo.svg';
import flag_wf__vallisfutuna__227 from '../../../../assets/img/flags/wf (vallisfutuna).svg';
import flag_ve_228 from '../../../../assets/img/flags/ve.svg';
import flag_vn_229 from '../../../../assets/img/flags/vn.svg';
import flag_ye_230 from '../../../../assets/img/flags/ye.svg';
import flag_ye_231 from '../../../../assets/img/flags/ye.svg';
import flag_nc_233 from '../../../../assets/img/flags/nc.svg';
import flag_nz_234 from '../../../../assets/img/flags/nz.svg';
import flag_gr_235 from '../../../../assets/img/flags/gr.svg';
import flag_cd_236 from '../../../../assets/img/flags/cd.svg';
import flag_zm_237 from '../../../../assets/img/flags/zm.svg';
import flag_tz_238 from '../../../../assets/img/flags/tz.svg';
import flag_zw_239 from '../../../../assets/img/flags/zw.svg';

// City and country data for registration form

export const cityItems = [
  { id: "34", name: "İstanbul", code: 1 },
  { id: "06", name: "Ankara", code: 2 },
  { id: "35", name: "İzmir", code: 3 },
  { id: "07", name: "Antalya", code: 4 },
  { id: "16", name: "Bursa", code: 5 },
  { id: "01", name: "Adana", code: 6 },
  { id: "20", name: "Denizli", code: 7 },
  { id: "27", name: "Gaziantep", code: 8 },
  { id: "02", name: "Adıyaman", code: 9 },
  { id: "03", name: "Afyonkarahisar", code: 10 },
  { id: "04", name: "Ağrı", code: 11 },
  { id: "05", name: "Amasya", code: 12 },
  { id: "08", name: "Artvin", code: 13 },
  { id: "09", name: "Aydın", code: 14 },
  { id: "10", name: "Balıkesir", code: 15 },
  { id: "11", name: "Bilecik", code: 16 },
  { id: "12", name: "Bingöl", code: 17 },
  { id: "13", name: "Bitlis", code: 18 },
  { id: "14", name: "Bolu", code: 19 },
  { id: "15", name: "Burdur", code: 20 },
  { id: "17", name: "Çanakkale", code: 21 },
  { id: "18", name: "Çankırı", code: 22 },
  { id: "19", name: "Çorum", code: 23 },
  { id: "21", name: "Diyarbakır", code: 24 },
  { id: "22", name: "Edirne", code: 25 },
  { id: "23", name: "Elazığ", code: 26 },
  { id: "24", name: "Erzincan", code: 27 },
  { id: "25", name: "Erzurum", code: 28 },
  { id: "26", name: "Eskişehir", code: 29 },
  { id: "28", name: "Giresun", code: 30 },
  { id: "29", name: "Gümüşhane", code: 31 },
  { id: "30", name: "Hakkari", code: 32 },
  { id: "31", name: "Hatay", code: 33 },
  { id: "32", name: "Isparta", code: 34 },
  { id: "33", name: "Mersin", code: 35 },
  { id: "36", name: "Kars", code: 36 },
  { id: "37", name: "Kastamonu", code: 37 },
  { id: "38", name: "Kayseri", code: 38 },
  { id: "39", name: "Kırklareli", code: 39 },
  { id: "40", name: "Kırşehir", code: 40 },
  { id: "41", name: "Kocaeli (İzmit)", code: 41 },
  { id: "42", name: "Konya", code: 42 },
  { id: "43", name: "Kütahya", code: 43 },
  { id: "44", name: "Malatya", code: 44 },
  { id: "45", name: "Manisa", code: 45 },
  { id: "46", name: "Kahramanmaraş", code: 46 },
  { id: "47", name: "Mardin", code: 47 },
  { id: "48", name: "Muğla", code: 48 },
  { id: "49", name: "Muş", code: 49 },
  { id: "50", name: "Nevşehir", code: 50 },
  { id: "51", name: "Niğde", code: 51 },
  { id: "52", name: "Ordu", code: 52 },
  { id: "53", name: "Rize", code: 53 },
  { id: "54", name: "Sakarya (Adapazarı)", code: 54 },
  { id: "55", name: "Samsun", code: 55 },
  { id: "56", name: "Siirt", code: 56 },
  { id: "57", name: "Sinop", code: 57 },
  { id: "58", name: "Sivas", code: 58 },
  { id: "59", name: "Tekirdağ", code: 59 },
  { id: "60", name: "Tokat", code: 60 },
  { id: "61", name: "Trabzon", code: 61 },
  { id: "62", name: "Tunceli", code: 62 },
  { id: "63", name: "Şanlıurfa", code: 63 },
  { id: "64", name: "Uşak", code: 64 },
  { id: "65", name: "Van", code: 65 },
  { id: "66", name: "Yozgat", code: 66 },
  { id: "67", name: "Zonguldak", code: 67 },
  { id: "68", name: "Aksaray", code: 68 },
  { id: "69", name: "Bayburt", code: 69 },
  { id: "70", name: "Karaman", code: 70 },
  { id: "71", name: "Kırıkkale", code: 71 },
  { id: "72", name: "Batman", code: 72 },
  { id: "73", name: "Şırnak", code: 73 },
  { id: "74", name: "Bartın", code: 74 },
  { id: "75", name: "Ardahan", code: 75 },
  { id: "76", name: "Iğdır", code: 76 },
  { id: "77", name: "Yalova", code: 77 },
  { id: "78", name: "Karabük", code: 78 },
  { id: "79", name: "Kilis", code: 79 },
  { id: "80", name: "Osmaniye", code: 80 },
  { id: "81", name: "Düzce", code: 81 }
];

export const countryItems = [
  { id: "90", name: "Türkiye", code: 90, flag: flag_tr_0, sCode: "tr" },
  { id: "1", name: "ABD", code: 1, flag: flag_us_1, sCode: "us" },
  { id: "93", name: "Afganistan", code: 93, flag: flag_af_2, sCode: "af" },
  { id: "49", name: "Almanya", code: 49, flag: flag_de_3, sCode: "de" },
  { id: "684", name: "Amerikan Samoa", code: 684, flag: flag_as_4, sCode: "as" },
  { id: "376", name: "Andorra", code: 376, flag: flag_ad_5, sCode: "ad" },
  { id: "244", name: "Angola", code: 244, flag: flag_ao_6, sCode: "ao" },
  { id: "1264", name: "Anguilla", code: 1264, flag: flag_ai_7, sCode: "ai" },
  { id: "1268", name: "Antigua", code: 1268, flag: flag_ag_8, sCode: "ag" },
  { id: "54", name: "Arjantin", code: 54, flag: flag_ar_9, sCode: "ar" },
  { id: "355", name: "Arnavutluk", code: 355, flag: flag_al_10, sCode: "al" },
  { id: "297", name: "Aruba", code: 297, flag: flag_aw_11, sCode: "aw" },
  { id: "247", name: "Ascension", code: 247, flag: flag_sh_ac_12, sCode: "sh-ac" },
  { id: "61", name: "Avustralya", code: 61, flag: flag_au_13, sCode: "au" },
  { id: "43", name: "Avusturya", code: 43, flag: flag_at_14, sCode: "at" },
  { id: "994", name: "Azerbaycan", code: 994, flag: flag_az_15, sCode: "az" },
  { id: "351", name: "Azor-Mader Adaları", code: 351, flag: flag_pt_16, sCode: "pt" },
  { id: "971", name: "B.A.E (B. Arap Emirlikleri)", code: 971, flag: flag_ae_17, sCode: "ae" },
  { id: "1242", name: "Bahama", code: 1242, flag: flag_bs_18, sCode: "bs" },
  { id: "973", name: "Bahreyn", code: 973, flag: flag_bh_19, sCode: "bh" },
  { id: "880", name: "Bangladeş", code: 880, flag: flag_bd_20, sCode: "bd" },
  { id: "1246", name: "Barbados", code: 1246, flag: flag_bb_21, sCode: "bb" },
  { id: "685", name: "Batı Samoa", code: 685, flag: flag_ws_22, sCode: "ws" },
  { id: "32", name: "Belçika", code: 32, flag: flag_be_23, sCode: "be" },
  { id: "501", name: "Belize", code: 501, flag: flag_bz_24, sCode: "bz" },
  { id: "229", name: "Benin", code: 229, flag: flag_bj_25, sCode: "bj" },
  { id: "1441", name: "Bermuda", code: 1441, flag: flag_bm_26, sCode: "bm" },
  { id: "375", name: "Beyaz Rusya", code: 375, flag: flag_by_27, sCode: "by" },
  { id: "975", name: "Bhutan", code: 975, flag: flag_bt_28, sCode: "bt" },
  { id: "95", name: "Birmanya", code: 95, flag: flag_mm_29, sCode: "mm" },
  { id: "591", name: "Bolivya", code: 591, flag: flag_bo_30, sCode: "bo" },
  { id: "387", name: "Bosna Hersek", code: 387, flag: flag_ba_31, sCode: "ba" },
  { id: "267", name: "Botsvana", code: 267, flag: flag_bw_32, sCode: "bw" },
  { id: "55", name: "Brezilya", code: 55, flag: flag_br_33, sCode: "br" },
  { id: "1284", name: "British Virgin Adl.", code: 1284, flag: flag_vg_34, sCode: "vg" },
  { id: "673", name: "Brunei", code: 673, flag: flag_bn_35, sCode: "bn" },
  { id: "359", name: "Bulgaristan", code: 359, flag: flag_bg_36, sCode: "bg" },
  { id: "226", name: "Burkina Faso", code: 226, flag: flag_bf_37, sCode: "bf" },
  { id: "257", name: "Burundi", code: 257, flag: flag_bi_38, sCode: "bi" },
  { id: "1345", name: "Cayman Adaları", code: 1345, flag: flag_ky_39, sCode: "ky" },
  { id: "350", name: "Cebelitarık", code: 350, flag: flag_gi_40, sCode: "gi" },
  { id: "213", name: "Cezayir", code: 213, flag: flag_dz_41, sCode: "dz" },
  { id: "253", name: "Cibuti", code: 253, flag: flag_dj_42, sCode: "dj" },
  { id: "682", name: "Cook Adası", code: 682, flag: flag_ck_43, sCode: "ck" },
  { id: "235", name: "Çad", code: 235, flag: flag_td_44, sCode: "td" },
  { id: "420", name: "Çek Cum.", code: 420, flag: flag_cz_45, sCode: "cz" },
  { id: "86", name: "Çin Halk Cum.", code: 86, flag: flag_cn_46, sCode: "cn" },
  { id: "45", name: "Danimarka", code: 45, flag: flag_dk_47, sCode: "dk" },
  { id: "246", name: "Diego Garsia", code: 246, flag: flag_dg_48, sCode: "dg" },
  { id: "1767", name: "Dominik", code: 1767, flag: flag_dm_49, sCode: "dm" },
  { id: "1809", name: "Dominik Cum.", code: 1809, flag: flag_do_50, sCode: "do" },
  { id: "593", name: "Ekvator", code: 593, flag: flag_ec_51, sCode: "ec" },
  { id: "240", name: "Ekvator Ginesi", code: 240, flag: flag_gq_52, sCode: "gq" },
  { id: "503", name: "ElSalvador", code: 503, flag: flag_sv_53, sCode: "sv" },
  { id: "62", name: "Endonezya", code: 62, flag: flag_id_54, sCode: "id" },
  { id: "291", name: "Erıtre", code: 291, flag: flag_er_55, sCode: "er" },
  { id: "374", name: "Ermenistan", code: 374, flag: flag_am_56, sCode: "am" },
  { id: "372", name: "Estonya", code: 372, flag: flag_ee_57, sCode: "ee" },
  { id: "251", name: "Etiyopya", code: 251, flag: flag_et_58, sCode: "et" },
  { id: "500", name: "Falkland Adl.", code: 500, flag: flag_fk_59, sCode: "fk" },
  { id: "298", name: "Faroe Adaları", code: 298, flag: flag_fo_60, sCode: "fo" },
  { id: "212", name: "Fas", code: 212, flag: flag_ma_61, sCode: "ma" },
  { id: "679", name: "Fiji", code: 679, flag: flag_fj_62, sCode: "fj" },
  { id: "225", name: "Fildişi Sahili", code: 225, flag: flag_ci_63, sCode: "ci" },
  { id: "63", name: "Filipinler", code: 63, flag: flag_ph_64, sCode: "ph" },
  { id: "358", name: "Finlandiya", code: 358, flag: flag_fi_65, sCode: "fi" },
  { id: "33", name: "Fransa", code: 33, flag: flag_fr_66, sCode: "fr" },
  { id: "594", name: "Fransız Guyanası", code: 594, flag: null, sCode: "fg" },
  { id: "689", name: "Fransız Polenezyası", code: 689, flag: flag_pf_68, sCode: "pf" },
  { id: "241", name: "Gabon", code: 241, flag: flag_ga_69, sCode: "ga" },
  { id: "220", name: "Gambia", code: 220, flag: flag_gm_70, sCode: "gm" },
  { id: "233", name: "Gana", code: 233, flag: flag_gh_71, sCode: "gh" },
  { id: "224", name: "Gine", code: 224, flag: flag_gn_72, sCode: "gn" },
  { id: "245", name: "Gine Bissau", code: 245, flag: flag_gw_73, sCode: "gw" },
  { id: "1473", name: "Grenada", code: 1473, flag: flag_gd_74, sCode: "gd" },
  { id: "299", name: "Grönland", code: 299, flag: flag_gl_75, sCode: "gl" },
  { id: "590", name: "Guadalup", code: 590, flag: flag_guadeloupe_76, sCode: "guadeloupe" },
  { id: "1671", name: "Guam", code: 1671, flag: flag_et__guam__77, sCode: "et (guam)" },
  { id: "502", name: "Guatemala", code: 502, flag: flag_fk__Guatemala__78, sCode: "fk (Guatemala)" },
  { id: "592", name: "Guyana", code: 592, flag: flag_gy_79, sCode: "gy" },
  { id: "27", name: "Güney Afrika Cum.", code: 27, flag: flag_za_80, sCode: "za" },
  { id: "995", name: "Gürcistan", code: 995, flag: flag_ge_81, sCode: "ge" },
  { id: "509", name: "Haiti", code: 509, flag: flag_ht_82, sCode: "ht" },
  { id: "385", name: "Hırvatistan", code: 385, flag: flag_hr_83, sCode: "hr" },
  { id: "91", name: "Hindistan", code: 91, flag: flag_in_84, sCode: "in" },
  { id: "31", name: "Hollanda", code: 31, flag: flag_nl_85, sCode: "nl" },
  { id: "599", name: "Hollanda Antilleri", code: 599, flag: flag_na__netherlandsantilles__86, sCode: "na (netherlandsantilles)" },
  { id: "504", name: "Honduras", code: 504, flag: flag_hn_87, sCode: "hn" },
  { id: "852", name: "Hong Kong", code: 852, flag: flag_hk_88, sCode: "hk" },
  { id: "964", name: "Irak", code: 964, flag: flag_iq_89, sCode: "iq" },
  { id: "1-vg", name: "İng. Virjin Adl.", code: 1, flag: flag_vg_90, sCode: "vg" },
  { id: "44", name: "İngiltere", code: 44, flag: flag_gb_91, sCode: "gb" },
  { id: "98", name: "İran", code: 98, flag: flag_ir_92, sCode: "ir" },
  { id: "353", name: "İrlanda", code: 353, flag: flag_ie_93, sCode: "ie" },
  { id: "972", name: "İsrail", code: 972, flag: flag_il_94, sCode: "il" },
  { id: "46", name: "İsveç", code: 46, flag: flag_se_95, sCode: "se" },
  { id: "41", name: "İsviçre", code: 41, flag: flag_ch_96, sCode: "ch" },
  { id: "39", name: "İtalya", code: 39, flag: flag_it_97, sCode: "it" },
  { id: "34", name: "İya", code: 34, flag: null, sCode: "empty" },
  { id: "354", name: "İzlanda", code: 354, flag: flag_is_99, sCode: "is" },
  { id: "1876", name: "Jamaika", code: 1876, flag: flag_jm_100, sCode: "jm" },
  { id: "81", name: "Japonya", code: 81, flag: flag_jp_101, sCode: "jp" },
  { id: "392", name: "K.K.T.C.", code: 392, flag: flag_cy_102, sCode: "cy" },
  { id: "855", name: "Kamboçya", code: 855, flag: flag_kh_103, sCode: "kh" },
  { id: "237", name: "Kamerun", code: 237, flag: flag_cm_104, sCode: "cm" },
  { id: "1-ca", name: "Kanada", code: 1, flag: flag_ca_105, sCode: "ca" },
  { id: "238", name: "Kap Verd.", code: 238, flag: flag_cv_106, sCode: "cv" },
  { id: "974", name: "Katar", code: 974, flag: flag_qa_107, sCode: "qa" },
  { id: "7", name: "Kazakistan", code: 7, flag: flag_kz_108, sCode: "kz" },
  { id: "254", name: "Kenya", code: 254, flag: flag_ke_109, sCode: "ke" },
  { id: "357", name: "Kıbrıs Rum Cum.", code: 357, flag: flag_cy_110, sCode: "cy" },
  { id: "996", name: "Kırgızistan", code: 996, flag: flag_kg_111, sCode: "kg" },
  { id: "686", name: "Kiribati", code: 686, flag: flag_ki_112, sCode: "ki" },
  { id: "57", name: "Kolombiya", code: 57, flag: flag_co_113, sCode: "co" },
  { id: "269", name: "Komor Adaları", code: 269, flag: flag_km_114, sCode: "km" },
  { id: "242", name: "Kongo Halk Cum.", code: 242, flag: flag_cd_115, sCode: "cd" },
  { id: "82", name: "Kore Cum. Güney", code: 82, flag: flag_kr_116, sCode: "kr" },
  { id: "506", name: "Kosta Rika", code: 506, flag: flag_cr_117, sCode: "cr" },
  { id: "965", name: "Kuveyt", code: 965, flag: flag_kw_118, sCode: "kw" },
  { id: "850", name: "Kuzey Kore", code: 850, flag: flag_kp_119, sCode: "kp" },
  { id: "53", name: "Küba", code: 53, flag: flag_cu_120, sCode: "cu" },
  { id: "856", name: "Lao Dem. Halk Cum.", code: 856, flag: flag_la_121, sCode: "la" },
  { id: "266", name: "Lesotho", code: 266, flag: flag_ls_122, sCode: "ls" },
  { id: "371", name: "Letonya", code: 371, flag: flag_lv_123, sCode: "lv" },
  { id: "231", name: "Liberya", code: 231, flag: flag_lr_124, sCode: "lr" },
  { id: "218", name: "Libya", code: 218, flag: flag_ly_125, sCode: "ly" },
  { id: "41-li", name: "Lihtenstayn", code: 41, flag: flag_li_126, sCode: "li" },
  { id: "370", name: "Litvanya", code: 370, flag: flag_lt_127, sCode: "lt" },
  { id: "961", name: "Lübnan", code: 961, flag: flag_lb_128, sCode: "lb" },
  { id: "352", name: "Lüksemburg", code: 352, flag: flag_lu_129, sCode: "lu" },
  { id: "36", name: "Macaristan", code: 36, flag: flag_hu_130, sCode: "hu" },
  { id: "261", name: "Madagaskar", code: 261, flag: flag_mg_131, sCode: "mg" },
  { id: "853", name: "Makao", code: 853, flag: flag_mo_132, sCode: "mo" },
  { id: "389", name: "Makedonya", code: 389, flag: flag_mk_133, sCode: "mk" },
  { id: "265", name: "Malavi", code: 265, flag: flag_mw_134, sCode: "mw" },
  { id: "960", name: "Maldiv Adaları", code: 960, flag: flag_mv_135, sCode: "mv" },
  { id: "60", name: "Malezya", code: 60, flag: flag_my_136, sCode: "my" },
  { id: "223", name: "Mali", code: 223, flag: flag_ml_137, sCode: "ml" },
  { id: "692", name: "Malsar Adaları", code: 692, flag: flag_mh_138, sCode: "mh" },
  { id: "356", name: "Malta", code: 356, flag: flag_mt_139, sCode: "mt" },
  { id: "1670", name: "Marian Adaları", code: 1670, flag: flag_mp_140, sCode: "mp" },
  { id: "596", name: "Martinik", code: 596, flag: flag_mq_141, sCode: "mq" },
  { id: "52", name: "Meksika", code: 52, flag: flag_mx_142, sCode: "mx" },
  { id: "236", name: "Merkezi Afrika Cum.", code: 236, flag: flag_cf_143, sCode: "cf" },
  { id: "20", name: "Mısır", code: 20, flag: flag_eg_144, sCode: "eg" },
  { id: "691", name: "Mikronezya", code: 691, flag: flag_fm_145, sCode: "fm" },
  { id: "976", name: "Moğolistan", code: 976, flag: flag_mn_146, sCode: "mn" },
  { id: "373", name: "Moldovya", code: 373, flag: flag_md_147, sCode: "md" },
  { id: "377", name: "Monaco", code: 377, flag: flag_mc_148, sCode: "mc" },
  { id: "1664", name: "Montserrat", code: 1664, flag: flag_ms_149, sCode: "ms" },
  { id: "230", name: "Moris Adaları", code: 230, flag: flag_mu_150, sCode: "mu" },
  { id: "222", name: "Moritanya", code: 222, flag: flag_mr_151, sCode: "mr" },
  { id: "258", name: "Mozambik", code: 258, flag: flag_mz_152, sCode: "mz" },
  { id: "7504915", name: "Nakhodka", code: 7504915, flag: flag_ru_153, sCode: "ru" },
  { id: "750492", name: "Nakhodka", code: 750492, flag: flag_ru_154, sCode: "ru" },
  { id: "264", name: "Namibya", code: 264, flag: flag_na_155, sCode: "na" },
  { id: "674", name: "Nauru Adası", code: 674, flag: flag_nr_156, sCode: "nr" },
  { id: "977", name: "Nepal", code: 977, flag: flag_np_157, sCode: "np" },
  { id: "227", name: "Nijer", code: 227, flag: flag_ne_158, sCode: "ne" },
  { id: "234", name: "Nijerya", code: 234, flag: flag_ng_159, sCode: "ng" },
  { id: "505", name: "Nikaragua", code: 505, flag: flag_ni_160, sCode: "ni" },
  { id: "683", name: "Niue Adaları", code: 683, flag: flag_nu_161, sCode: "nu" },
  { id: "672", name: "Norfolk Adaları", code: 672, flag: flag_nf_162, sCode: "nf" },
  { id: "47", name: "Norveç", code: 47, flag: flag_no_163, sCode: "no" },
  { id: "998", name: "Özbekistan", code: 998, flag: flag_uz_164, sCode: "uz" },
  { id: "92", name: "Pakistan", code: 92, flag: flag_pk_165, sCode: "pk" },
  { id: "680", name: "Palau", code: 680, flag: flag_pw_166, sCode: "pw" },
  { id: "507", name: "Panama", code: 507, flag: flag_pa_167, sCode: "pa" },
  { id: "675", name: "Papua Yeni Gine", code: 675, flag: flag_pg_168, sCode: "pg" },
  { id: "595", name: "Paraguay", code: 595, flag: flag_py_169, sCode: "py" },
  { id: "51", name: "Peru", code: 51, flag: flag_pe_170, sCode: "pe" },
  { id: "48", name: "Polonya", code: 48, flag: flag_pl_171, sCode: "pl" },
  { id: "351-pt", name: "Portekiz", code: 351, flag: flag_pt_172, sCode: "pt" },
  { id: "1787", name: "Puerto Rico", code: 1787, flag: flag_pr_173, sCode: "pr" },
  { id: "750996", name: "Radius", code: 750996, flag: flag_ru_174, sCode: "ru" },
  { id: "262", name: "Reunyon", code: 262, flag: flag_reunyon_175, sCode: "reunyon" },
  { id: "40", name: "Romanya", code: 40, flag: flag_ro_176, sCode: "ro" },
  { id: "250", name: "Ruanda", code: 250, flag: flag_rw_177, sCode: "rw" },
  { id: "7-ru", name: "Rusya Federasyonu", code: 7, flag: flag_ru_178, sCode: "ru" },
  { id: "750440", name: "Sakhalın", code: 750440, flag: flag_ru_179, sCode: "ru" },
  { id: "7504416", name: "Sakhalın", code: 7504416, flag: flag_ru_180, sCode: "ru" },
  { id: "750442", name: "Sakhalın", code: 750442, flag: flag_ru_181, sCode: "ru" },
  { id: "750443", name: "Sakhalın", code: 750443, flag: flag_ru_182, sCode: "ru" },
  { id: "378", name: "San Marino", code: 378, flag: flag_sm_183, sCode: "sm" },
  { id: "239", name: "Sao Tome", code: 239, flag: flag_st_184, sCode: "st" },
  { id: "221", name: "Senegal", code: 221, flag: flag_sn_185, sCode: "sn" },
  { id: "248", name: "Seychelles", code: 248, flag: flag_sc_186, sCode: "sc" },
  { id: "381", name: "Sırbistan", code: 381, flag: flag_rs_187, sCode: "rs" },
  { id: "232", name: "Sierra Leone", code: 232, flag: flag_sl_188, sCode: "sl" },
  { id: "65", name: "Singapur", code: 65, flag: flag_sg_189, sCode: "sg" },
  { id: "421", name: "Slovak Cum.", code: 421, flag: flag_sk_190, sCode: "sk" },
  { id: "386", name: "Slovenya", code: 386, flag: flag_si_191, sCode: "si" },
  { id: "677", name: "Solomon Adaları", code: 677, flag: flag_sb_192, sCode: "sb" },
  { id: "252", name: "Somali", code: 252, flag: flag_so_193, sCode: "so" },
  { id: "94", name: "Sri Lanka", code: 94, flag: flag_lk_194, sCode: "lk" },
  { id: "290", name: "St. Helena", code: 290, flag: null, sCode: "sh-hl " },
  { id: "1869", name: "St. Kitts", code: 1869, flag: flag_kn_196, sCode: "kn" },
  { id: "1758", name: "St. Lucia", code: 1758, flag: flag_lc_197, sCode: "lc" },
  { id: "5995", name: "St. Marten", code: 5995, flag: flag_sx_198, sCode: "sx" },
  { id: "508", name: "St. Pierre", code: 508, flag: flag_pm_199, sCode: "pm" },
  { id: "1784", name: "St. Vincent", code: 1784, flag: flag_vc_200, sCode: "vc" },
  { id: "249", name: "Sudan", code: 249, flag: flag_sd_201, sCode: "sd" },
  { id: "597", name: "Surinam", code: 597, flag: flag_sr_202, sCode: "sr" },
  { id: "963", name: "Suriye", code: 963, flag: flag_sy_203, sCode: "sy" },
  { id: "966", name: "Suudi Arabistan", code: 966, flag: flag_sa_204, sCode: "sa" },
  { id: "268", name: "Svaziland", code: 268, flag: flag_sz_205, sCode: "sz" },
  { id: "56", name: "Şili", code: 56, flag: flag_cl_206, sCode: "cl" },
  { id: "7-tj", name: "Tacikistan", code: 7, flag: flag_tj_207, sCode: "tj" },
  { id: "255", name: "Tanzanya", code: 255, flag: flag_tz_208, sCode: "tz" },
  { id: "7843", name: "Tataristan", code: 7843, flag: flag_ru_209, sCode: "ru" },
  { id: "7513", name: "Tatıncom", code: 7513, flag: flag_ru_210, sCode: "ru" },
  { id: "66", name: "Tayland", code: 66, flag: flag_th_211, sCode: "th" },
  { id: "886", name: "Tayvan", code: 886, flag: flag_tw_212, sCode: "tw" },
  { id: "228", name: "Togo", code: 228, flag: flag_tg_213, sCode: "tg" },
  { id: "690", name: "Tokelan", code: 690, flag: flag_tk_214, sCode: "tk" },
  { id: "676", name: "Tonga", code: 676, flag: flag_to_215, sCode: "to" },
  { id: "1868", name: "Trinidad Tobago", code: 1868, flag: flag_tt_216, sCode: "tt" },
  { id: "216", name: "Tunus", code: 216, flag: flag_tn_217, sCode: "tn" },
  { id: "1649", name: "Turks Caicos Adl.", code: 1649, flag: flag_tc_218, sCode: "tc" },
  { id: "688", name: "Tuvalu", code: 688, flag: flag_tv_219, sCode: "tv" },
  { id: "993", name: "Türkmenistan", code: 993, flag: flag_tm_220, sCode: "tm" },
  { id: "1340", name: "U.S. Virgin Adl.", code: 1340, flag: flag_vi_221, sCode: "vi" },
  { id: "256", name: "Uganda", code: 256, flag: flag_ug_222, sCode: "ug" },
  { id: "380", name: "Ukrayna", code: 380, flag: flag_ua_223, sCode: "ua" },
  { id: "968", name: "Umman", code: 968, flag: flag_om_224, sCode: "om" },
  { id: "598", name: "Uraguay", code: 598, flag: flag_uy_225, sCode: "uy" },
  { id: "962", name: "Ürdün", code: 962, flag: flag_jo_226, sCode: "jo" },
  { id: "681", name: "Vallis Futuna Adl.", code: 681, flag: flag_wf__vallisfutuna__227, sCode: "wf (vallisfutuna)" },
  { id: "58", name: "Venezuela", code: 58, flag: flag_ve_228, sCode: "ve" },
  { id: "84", name: "Vietnam", code: 84, flag: flag_vn_229, sCode: "vn" },
  { id: "967", name: "Yemen Arap Cum.", code: 967, flag: flag_ye_230, sCode: "ye" },
  { id: "969", name: "Yemen Halk Cum.", code: 969, flag: flag_ye_231, sCode: "ye" },
  { id: "678", name: "Yeni Hebritler", code: 678, flag: null, sCode: "vu" },
  { id: "687", name: "Yeni Kaledonya", code: 687, flag: flag_nc_233, sCode: "nc" },
  { id: "64", name: "Yeni Zelenda", code: 64, flag: flag_nz_234, sCode: "nz" },
  { id: "30", name: "Yunanistan", code: 30, flag: flag_gr_235, sCode: "gr" },
  { id: "243", name: "Zaire", code: 243, flag: flag_cd_236, sCode: "cd" },
  { id: "260", name: "Zambiya", code: 260, flag: flag_zm_237, sCode: "zm" },
  { id: "259", name: "Zanzibar", code: 259, flag: flag_tz_238, sCode: "tz" },
  { id: "263", name: "Zimbabve", code: 263, flag: flag_zw_239, sCode: "zw" }
];

export const interestedProducts = [
  { id: 1, name: "Hisse", selected: false, code: "Stock" },
  { id: 2, name: "Hisse ve Türev", selected: false, code: "StockAndDerivative" },
  { id: 3, name: "Döviz ve Türev", selected: false, code: "ExchangeAndDerivative" },
];

export const investmentAmount = [
  { id: 4, name: "Belirtmek istemiyorum", selected: false, code: "NotSpecified" },
  { id: 1, name: "1 milyon altı", selected: false, code: "UnderMillion" },
  { id: 2, name: "1-10 milyon", selected: false, code: "MillionBetween" },
  { id: 3, name: "10 milyon üstü", selected: false, code: "Over10Million" },
];

// Helper function to get country code by name
export const getCountryCode = (countryName) => {
  const country = countryItems.find((country) => country.name === countryName);
  return country ? country.code : '';
};
